import { loginUrl, authPreflightUrl } from '../lib/paths';
import { usePostApi, usePostData } from '../lib/hooks/requests';

export const useLogin = () => {
  return usePostApi(loginUrl);
};

export const useAuthPreflight = () => {
  return usePostData(authPreflightUrl);
};
